module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/other-1-815cfe08e2ff0f2af92a57eebc8ed29b.svg";